import { useContext } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import FutureExitContext from 'pages/ValuationsAllocation/approaches/FutureExit/utils/FutureExitContext';
import { metricValueListStyles } from './FutureEquityLists.styles';

const MetricValueSelect = (props: any) => {
  const { metricOptions } = useContext(FutureExitContext);

  return (
    <GridSelect
      enumerated
      extraStyles={metricValueListStyles}
      menuPosition="absolute"
      options={metricOptions}
      {...props}
    />
  );
};

export default MetricValueSelect;
